import { request } from "./http";

export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  scopes: string[];
  expires_at: string | null;
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

export interface ApiKeyCreated extends ApiKey {
  plaintext: string;
}

export const apiKeys = {
  list: () => request<ApiKey[]>("/api/v1/me/api-keys"),
  create: (body: { name: string; scopes: string[]; expires_at?: string | null }) =>
    request<ApiKeyCreated>("/api/v1/me/api-keys", { body }),
  revoke: (id: string) =>
    request<{ id: string; status: string }>(`/api/v1/me/api-keys/${id}`, {
      method: "DELETE",
    }),
};
